import { TableContainer, Table, TableHead, TableRow, Typography, TableBody, Button, Grid } from '@material-ui/core';
import { AddBox, Cancel, Check, Delete, Edit } from '@material-ui/icons';
import { AutocompleteForm, FormatNumber, TextFieldNumber } from 'components';
import { StyledTableCell } from 'components/TablaV2';
import { useState } from 'react';
import { Controller } from 'react-hook-form';

export default function ListaMiembrosTareaCerrar({ control, name, rules, totalHAsignar, defaultResponsables }) {
    return (
        <Controller
            render={({ value, onChange }) => {
                const horasTarea = (defaultResponsables || [])?.reduce((horas, persona) => horas + Number(persona.horas), 0);
                const horasRestantes = value.reduce((horas, persona) => horas - persona.horas, totalHAsignar + horasTarea);
                const habilitarEditar = (miembroEditar, habilitar) => () => {
                    onChange(
                        value.map(miembro =>
                            miembro.idpersona == miembroEditar.idpersona
                                ? { ...miembroEditar, accion: habilitar ? 'updA' : null }
                                : { ...miembro, accion: null }
                        )
                    );
                };
                return (
                    <Grid container>
                        <Grid item xs={12}>
                            <TableContainer>
                                <Table aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell style={{ width: '60%' }}>MIEMBRO DEL EQUIPO</StyledTableCell>
                                            <StyledTableCell style={{ width: '15%' }}>
                                                HORAS
                                            </StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {value.map(miembro => {
                                            return (
                                                <TableRow key={miembro.idpersona}>
                                                    <StyledTableCell component="th">{miembro.nombre}</StyledTableCell>
                                                    <StyledTableCell>
                                                        <TextFieldNumber
                                                            onChange={horas => habilitarEditar({ ...miembro, horas: horas }, true)()}
                                                            value={miembro.horas}
                                                            isAllowed={({ floatValue, formattedValue }) =>
                                                                formattedValue === '' || floatValue > 0
                                                            }
                                                            suffix=" hr"
                                                        />
                                                    </StyledTableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                );
            }}
            defaultValue={defaultResponsables || []}
            rules={rules}
            name={name}
            control={control}
        />
    );
}
